export default __webpack_public_path__ + "static/about-us-hero-1e6ec39ed5cb8bbef05587bf6d50a2da.webp";